import { Pipe, PipeTransform } from '@angular/core';
import { SelectItem } from 'primeng/api';

@Pipe({
  name: 'multiselectKeysToValue'
})
export class MultiselectKeysToValuePipe implements PipeTransform {

  transform(keyList: string, selectList: SelectItem[] = [], separator = '|'): string {
    let valueString: string = '';
    try {
      let keys: string[] = keyList.split(separator);
      if (keys.length > 0) {
        selectList.map(item => {
          if (keys.find(key => key === item.value)) {
            valueString.length > 0 ? valueString = valueString.concat(', ', item.label) : valueString = item.label;
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
    return valueString;
  }
}
